var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"vuestic-layout",class:_vm.classObject},[_vm._t("default"),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }